var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0073b1",
    d: "M19.5.5c.797 0 1.5.703 1.5 1.547V20a1.51 1.51 0 0 1-1.5 1.5H1.453C.656 21.5 0 20.844 0 20V2.047C0 1.203.656.5 1.453.5zm-13.172 18V8.516H3.234V18.5zM4.781 7.109a1.78 1.78 0 0 0 1.781-1.781c0-.984-.797-1.828-1.781-1.828a1.83 1.83 0 0 0-1.828 1.828c0 .984.797 1.781 1.828 1.781M18 18.5v-5.484c0-2.672-.609-4.781-3.75-4.781-1.5 0-2.531.844-2.953 1.641h-.047v-1.36H8.297V18.5h3.094v-4.922c0-1.312.234-2.578 1.875-2.578 1.594 0 1.594 1.5 1.594 2.625V18.5z"
  })));
};
export default SvgLinkedin;